import { useEffect, useRef, useState } from 'react';
import { OptionMenuProps } from './types';

export const Menu = ({ children, classNames, position, menuComponent }: OptionMenuProps) => {
    let optionMenuPosition = '';
    const [toggleOptionMenu, setToggleOptionMenu] = useState(false);
    const optionMenuBtn = useRef<any>(null);
    const optionMenuContent = useRef<any>(null);

    useEffect(() => {
        document.addEventListener('click', handleToggleOptionMenuToggle, true);
        return () => {
            document.removeEventListener('click', handleToggleOptionMenuToggle, true);
        };
    }, [toggleOptionMenu]);

    const handleToggleOptionMenuToggle = (e: any) => {
        const nestedMenuBtnElemnet = e.target?.closest('.option-menu')?.children[0];
        const isNestedMenuBtnElementClicked: boolean = typeof e.target?.className === 'string' && e.target?.className?.includes('toggle-closest');
        const isCloseClicked: boolean = typeof e.target?.className === 'string' && e.target?.className?.includes('close');
        if (optionMenuBtn.current === e.target) {
            setToggleOptionMenu((prev: boolean) => !prev);
        } else if (nestedMenuBtnElemnet == optionMenuBtn.current && isNestedMenuBtnElementClicked) {
            nestedMenuBtnElemnet.click();
        } else if (isCloseClicked) {
            setToggleOptionMenu(false);
        } else if (optionMenuContent.current.contains(e.target)) {
            setToggleOptionMenu(true);
        } else {
            setToggleOptionMenu(false);
        }
    };

    const optionMenuToggleClass = toggleOptionMenu ? '' : 'hidden';

    switch (position) {
        case 'left': {
            optionMenuPosition = 'right-5 translate-x-1/2 top-full md:right-full md:top-0 md:-translate-x-1';
            break;
        }
        case 'right': {
            optionMenuPosition = 'left-full top-0 translate-x-1';
            break;
        }
        case 'center': {
            optionMenuPosition = 'left-1/2 -translate-x-1/2 top-full';
            break;
        }
        case 'top': {
            optionMenuPosition = 'left-0 bottom-full -translate-y-1';
            break;
        }
        case 'bottom': {
            optionMenuPosition = 'left-0 top-full translate-y-1';
            break;
        }
        case 'bottom-right': {
            optionMenuPosition = 'right-0 top-full translate-y-1';
            break;
        }
        default: {
            optionMenuPosition = 'left-0 top-full translate-y-1';
            break;
        }
    }

    return (
        <div className="relative flex-none option-menu">
            <button className={`${classNames || 'w-full cursor-pointer hover:bg-white focus:bg-white rounded-button transition-colors ease-in-out duration-200'}`} ref={optionMenuBtn}>
                <div className="pointer-events-none">{menuComponent}</div>
            </button>
            <nav
                className={`absolute ${optionMenuPosition} w-[calc(100%-1.5rem)] min-w-48 bg-white rounded-md shadow-xl z-30 option-menu-content ${optionMenuToggleClass}`}
                ref={optionMenuContent}
            >
                <ul className="py-2">{children}</ul>
            </nav>
        </div>
    );
};
